import { createReducer } from "../../../utils/redux/create-reducer";
import Types from "./types";

export const INITIAL_STATE = {
    isSsr: true,
    cmsDetails: {},
    isInvalidCity: false
};

export const setSSRStatus = (state = INITIAL_STATE, { isSsr }) => {
    return { ...state, isSsr };
};

export const setDetails = (state = INITIAL_STATE, { data }) => {
    return { ...state, ...data };
};

export const HANDLERS = {
    [Types.SET_SSR_STATUS]: setSSRStatus,
    [Types.SET_DETAILS]: setDetails
};

export default createReducer(INITIAL_STATE, HANDLERS);
